import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { CardinalityModel } from './cardinality.model';

export function createInitialState(): TableCardinalityState {
  return {
    tableCardinality: null,
    loading: true,
  };
}

export interface TableCardinalityState {
  loading: boolean;
  tableCardinality: CardinalityModel | null;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'table-cardinality' })
export class TableCardinalityStore extends Store<TableCardinalityState> {
  constructor() {
    super(createInitialState());
  }
}
